import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import {
  ApartmentOutlined,
  CreditCardOutlined,
  LogoutOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Menu, Dropdown, Avatar } from 'antd'
import store from 'store'
import userActions, { getUserDetailedInfo, getUserProfileImage } from 'redux/user/actions'
import { capitalizeFirstLetter, getProfileImageInfo, getLoggedInUserInfo, logoutUser } from 'utils'
import { userRoleEnums } from 'enums/userRole'
import EmailWithTooltip from 'components/EmailWithTooltip'
import styles from './style.module.scss'

const mapStateToProps = ({ user }) => ({ user })

const ProfileMenu = ({ user, dispatch }) => {
  const imageUrl = user?.userProfileImageUrl
  const logout = (e) => {
    e.preventDefault()
    if (user?.userProfileImageUrl) {
      URL.revokeObjectURL(user.userProfileImageUrl)
    }
    dispatch({ type: userActions.USER_LOGOUT })
    store.set('app.menu.openedKeys', [])
    store.set('app.menu.selectedKeys', [])
    // Clears every session store and lands on /auth/login. Dropping only the access
    // token used to leave the refresh token behind, which the axios interceptor could
    // then trade for a fresh token and revive a session the user had just ended.
    logoutUser()
  }
  const userId = user?.userInfo?.userId
  useEffect(() => {
    const imageInfo = getProfileImageInfo(user?.userDetailedInfo?.userProfileImg)
    dispatch(getUserProfileImage(imageInfo?.id || null))
  }, [dispatch, user?.userDetailedInfo?.userProfileImg])

  useEffect(() => {
    if (userId) {
      const fetchUserDetails = async () => {
        try {
          await dispatch(getUserDetailedInfo(userId))
        } catch (error) {
          console.log(error)
        }
      }
      fetchUserDetails()
    }
  }, [dispatch, userId])

  const isAdmin = getLoggedInUserInfo()?.userRole === userRoleEnums?.ADMIN
  const userName =
    (user?.userDetailedInfo?.userName && capitalizeFirstLetter(user.userDetailedInfo.userName)) ||
    'Anonymous'

  const menu = (
    <Menu className={styles.profileMenu} selectable={false}>
      <Menu.Item className={styles.profileSummary} disabled>
        <strong className={styles.profileGreeting}>
          <span className={styles.profileGreetingLabel}>
            <FormattedMessage id="topBar.profileMenu.hello" />,
          </span>
          <span className={styles.profileName} title={userName}>
            {userName}
          </span>
        </strong>
        {/* <div>
          <strong>
            <FormattedMessage id="topBar.profileMenu.role" />:{' '}
          </strong>
          {user?.userInfo?.userRole || '—'}
        </div> */}
      </Menu.Item>
      <Menu.Item className={styles.profileEmail} disabled>
        <div className={styles.profileEmailContent}>
          <strong>
            <FormattedMessage id="topBar.profileMenu.email" />:{' '}
          </strong>
          <EmailWithTooltip
            email={user?.userDetailedInfo?.userEmail}
            className={styles.profileEmailValue}
          />
          {/* <br />
          <strong>
            <FormattedMessage id="topBar.profileMenu.phone" />:{' '}
          </strong>
          {user.phone || '—'} */}
        </div>
      </Menu.Item>

      {isAdmin && (
        <Menu.Item className={styles.menuItem}>
          <a href="/account-settings">
            <CreditCardOutlined />
            <FormattedMessage id="topBar.profileMenu.accountSettings" />
          </a>
        </Menu.Item>
      )}
      {isAdmin}
      <Menu.Item className={styles.menuItem}>
        <a href="/profile">
          <UserOutlined />
          <FormattedMessage id="topBar.profileMenu.editProfile" />
        </a>
      </Menu.Item>

      {isAdmin && (
        <Menu.Item className={styles.menuItem}>
          <a href="/config/company-profile">
            <ApartmentOutlined />
            <FormattedMessage id="topBar.profileMenu.companyProfile" />
          </a>
        </Menu.Item>
      )}

      <Menu.Item className={`${styles.menuItem} ${styles.logoutItem}`}>
        <a href="#" onClick={logout}>
          <LogoutOutlined />
          <FormattedMessage id="topBar.profileMenu.logout" />
        </a>
      </Menu.Item>
    </Menu>
  )
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px', // space between username and avatar
        cursor: 'pointer',
      }}
    >
      {/* <div style={{ textAlign: 'right', lineHeight: 1.3 }}>
        <div style={{ fontWeight: 700, fontSize: 14, color: '#1a2340' }}>
          {user?.userDetailedInfo?.userName || 'N/A'}
        </div>
        <div
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: '#8c97b2',
            textTransform: 'uppercase',
            letterSpacing: '0.4px',
          }}
        >
          {user?.userDetailedInfo?.role?.displayName || 'N/A'}
        </div>
      </div> */}
      <Dropdown overlay={menu} trigger={['click']}>
        <div className={styles.dropdown} id="profile">
          <Avatar
            className={styles.avatar}
            shape="circle"
            size="large"
            src={imageUrl}
            icon={<UserOutlined />}
            style={{ border: '2px solid #14b8a6' }}
          />
        </div>
      </Dropdown>
    </div>
  )
}

export default connect(mapStateToProps)(ProfileMenu)
